<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl3 lg4 xs6>
                      <v-text-field v-model="filters.b2cKey" :label="filtersLabel.b2cKey" :error-messages="errors.collect('b2cKey')" data-vv-name="b2cKey" :data-vv-as="filtersLabel.b2cKey" v-validate="'param|max:60'"></v-text-field>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-autocomplete :items="intermediaryList" v-model="filters.intermediary" :label="filtersLabel.intermediary" item-text="label" item-value="value" data-vv-name="intermediary" :data-vv-as="filtersLabel.intermediary" :error-messages="errors.collect('intermediary')" clearable></v-autocomplete>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <cal-picker v-model="filters.dateOpened" :label="filtersLabel.dateOpened" :data-vv-as="filtersLabel.dateOpened" data-vv-name="dateOpened" :error-messages="errors.collect('dateOpened')"></cal-picker>
                    </v-flex>
                    <v-flex xl3 lg4 xs6>
                      <v-checkbox v-model="filters.isActive" :label="filtersLabel.isActive" :error-messages="errors.collect('isActive')" data-vv-name="isActive" :data-vv-as="filtersLabel.isActive"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">B2C Keys Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="b2cKey" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.b2cKey }}</td>
              <td class="text-xs-right">{{ props.item.intermediary }}</td>
              <td class="text-xs-right">{{ props.item.isActive ? 'Yes' : 'No' }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.dateOpened) }}</td>
              <td class="text-xs-right">{{ formatDate(props.item.dateClosed) }}</td>
              <td class="text-xs-right">
                <table-action :rowData="props" :review="checkAccess(['b2cKeyReview'])" :remove="checkAccess(['b2cKeyReview'])" @review="doReview" @remove="doPromptRemove"></table-action>
              </td>
            </template>
          </v-data-table>
        </v-card>
        <div class="pt-2">
          <v-btn color="primary" @click="doNew">
            Add B2C Key
            <v-icon right>mdi-key-plus</v-icon>
          </v-btn>
        </div>
      </v-flex>
    </v-layout>
    <confirm v-model="promptRemove" @ok="doRemove">
      Are you sure you want to delete B2C Key - {{removeId}}?
    </confirm>
  </page>
</template>

<script>
import clone from 'clone'
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import toDate from 'date-fns/toDate'
import { ADMINB2C_KEYS_INTERMEDIARY } from '@/store/types'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { extractMenu } from '@/utils/extract'

export default {
  data() {
    return {
      headers: [
        { text: 'Key', align: 'left', value: 'b2cKey' },
        { text: 'Intermediary.', align: 'right', value: 'intermediary' },
        { text: 'Is Active', align: 'right', value: 'isActive' },
        { text: 'Date Opened', align: 'right', value: 'dateOpened' },
        { text: 'Date Closed', align: 'right', value: 'dateClosed' },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      filters: {
        b2cKey: null,
        intermediary: null,
        isActive: null,
        dateOpened: null
      },
      filtersLabel: {
        b2cKey: 'Key',
        intermediary: 'Intermediary',
        isActive: 'Is Active',
        dateOpened: 'Effective Date'
      },
      promptRemove: false,
      removeId: null
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    intermediaryList() {
      return this.$store.state.adminB2c.keys.intermediaryList
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.adminB2c.keys.menu.listing
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          // Massage the filters
          let massageFilters = clone(this.filters)
          if (massageFilters.dateOpened) {
            massageFilters.dateOpened = formatDisplayDateTime2(removeTime(massageFilters.dateOpened))
          }

          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), massageFilters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((key) => {
                const convertKey = {
                  b2cKey: key.b2cKey,
                  inter: key.intermediary,
                  intermediary: key.intermediaryName,
                  isActive: key.isActive,
                  dateOpened: toDate(key.dateOpened),
                  dateClosed: key.dateClosed ? toDate(key.dateClosed) : null,
                  menu: extractMenu(key._links)
                }
                this.items.push(convertKey)
              })
            } else {
              this.items = []
            }
            if (options) {
              this.$store.commit(ADMINB2C_KEYS_INTERMEDIARY, result.data.intermediaryList)
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClearFilters() {
      this.filters.b2cKey = null
      this.filters.intermediary = null
      this.filters.isActive = null
      this.filters.dateOpened = null
      this.fetchData(false)
    },
    doReview(data) {
      if (data && data.item && data.item.b2cKey) {
        this.$router.push({ name: 'b2cKeyReview', params: { id: data.item.b2cKey, inter: data.item.inter } })
      }
    },
    doPromptRemove(data) {
      if (data && data.item && data.item.b2cKey) {
        this.removeId = data.item.b2cKey
        this.promptRemove = true
      }
    },
    async doRemove() {
      const toDelete = this.items.find(x => x.b2cKey === this.removeId)
      if (toDelete && toDelete.menu && toDelete.menu.deleteKey) {
        try {
          this.loading = true
          const result = await this.$http.delete(toDelete.menu.deleteKey)
          if (result.data) {
            this.message(result.data)

            // Refetch data
            this.fetchData(false)
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Failed to remove ' + this.removeId)
      }
    },
    doNew() {
      this.$router.push({ name: 'b2cKeyReview', params: { id: 'new' } })
    }
  },
  mounted() {
    // Fetch Keys Data
    this.fetchData(true)
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
